// extracted by mini-css-extract-plugin
export default {"btn__view":"BtnPurple_btn__view__2T6Wb"};